module.exports = __webpack_public_path__ + "static/media/loading_screen@3x.b10629c6.jpg";